"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;
var _redux = require("redux");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _reduxPromise = _interopRequireDefault(require("redux-promise"));
var _nuiShell = require("@concur/nui-shell");
var _rootReducer = _interopRequireDefault(require("./rootReducer"));
var _utils = require("../utils");
var _analytics = _interopRequireDefault(require("../analytics/analytics"));
var _listingModule = require("../listing/listingModule");
var _listingsModule = require("../listings/listingsModule");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var store = null;
var connectSectionPercentageAsNumber = Number(process.env.CONNECT_SECTION_PERCENTAGE);
var NEW_CONNECT_SECTION_PERCENTAGE = Number.isNaN(connectSectionPercentageAsNumber) ? 0 : connectSectionPercentageAsNumber;
var COOKIE_CONSENT_COOKIE_NAME = 'notice_preferences';
function isAdobeAnalyticsAllowed() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    cookies = _ref.cookies;
  if (process.env.NODE_ENV !== 'production') {
    return false;
  }
  if (!Object.prototype.hasOwnProperty.call(cookies, COOKIE_CONSENT_COOKIE_NAME)) {
    return true;
  }
  var consentCookieValue = cookies[COOKIE_CONSENT_COOKIE_NAME];
  if (consentCookieValue === '1:' || consentCookieValue === '2:') {
    return true;
  }
  return false;
}
function configureStore(initialState) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var utilityFns = arguments.length > 2 ? arguments[2] : undefined;
  if (!initialState.userPrefs.userId) {
    initialState.userPrefs = _objectSpread(_objectSpread({}, initialState.userPrefs), {}, {
      userId: ''
    });
  }
  var createStoreWithMiddleware;
  var customReduxMiddleware = _nuiShell.nuiReduxMiddlewares.customize({
    analytics: function analytics(mw) {
      return mw.withOptions({
        mapStateToAnalytics: _analytics.default
      });
    }
  });
  if (process.env.NODE_ENV !== 'production' && (0, _utils.isClient)() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    var _require = require('redux-logger'),
      createLogger = _require.createLogger;
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    createStoreWithMiddleware = composeEnhancers(_redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default, createLogger({
      level: 'info',
      collapsed: true
    })])))(_redux.createStore);
  } else {
    createStoreWithMiddleware = _redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default]))(_redux.createStore);
  }
  if (!(0, _utils.isClient)()) {
    // this only works with webpack because of the Ignore plugin in config
    var ConcurProtect = require('@concur/concur-protect');

    // TripIt expects to decode using `_protectKey` from session
    // ConcurProtect knowns to grab this field and use it if present
    var otProtectCSRF = new ConcurProtect(req.session);
    var encryptUserId = utilityFns.encryptUserId;
    if (req.session && req.session.UserID) {
      if (process.env.FIPS_ENABLED === 'true') {
        var PT_AESGCM_FIPS_C = 'c';
        initialState.userPrefs = _objectSpread(_objectSpread({}, initialState.userPrefs), {}, {
          userId: encryptUserId(req.session.UserID, true),
          csrf_token: otProtectCSRF.protectValue('csrf_token', req.session.SessionId, PT_AESGCM_FIPS_C)
        });
      } else {
        initialState.userPrefs = _objectSpread(_objectSpread({}, initialState.userPrefs), {}, {
          userId: encryptUserId(req.session.UserID),
          csrf_token: otProtectCSRF.protectValue('csrf_token', req.session.SessionId)
        });
      }
    }
    var originalhost = (0, _utils.sanitizeOriginalHost)(req.headers['original-host'] || req.cookies['cnqr-original-host'] || req.hostname || '');
    var country = (0, _utils.getCountryCode)(originalhost);
    initialState.meta = _objectSpread(_objectSpread(_objectSpread({}, initialState.meta), {}, {
      originalhost: originalhost,
      country: country,
      listingNotFound: req.listingNotFound
    }, req.publicMenuData ? {
      publicMenuData: req.publicMenuData
    } : null), {}, {
      useNewConnectionSection: Math.random() * 100 < NEW_CONNECT_SECTION_PERCENTAGE || req.query.useNewConnectionSection === 'true',
      inDevelopmentMode: process.env.NODE_ENV !== 'production'
    });
    initialState.baseUrl = (0, _utils.getNuiBaseUrlFromHost)(originalhost);
  }
  initialState.listing = _objectSpread(_objectSpread({}, initialState.listing), _listingModule.initialState);
  if (req.data) {
    initialState.listing = _objectSpread(_objectSpread({}, initialState.listing), {}, _defineProperty({}, req.listingId, {
      readyState: _listingModule.LISTING_FETCHED,
      data: req.data
    }));
  }
  if (req.categories) {
    initialState.listings = _objectSpread(_objectSpread({}, _listingsModule.initialState), {}, {
      categoriesReadyState: _listingsModule.CATEGORIES_FETCHED,
      categories: req.categories
    });
  }
  if (req.category) {
    initialState.listings = _objectSpread(_objectSpread(_objectSpread({}, _listingsModule.initialState), initialState.listings), {}, {
      categoryFilter: [req.category],
      search: ''
    });
  }
  if (req.location) {
    initialState.listing = _objectSpread(_objectSpread({}, initialState.listing), {}, {
      localizedRegions: req.location.localizedRegions,
      localizedCountries: req.location.localizedCountries
    });
  }
  if (req.userProfile) {
    initialState.userProfile = req.userProfile;
  }

  // Adding betas as its own reducer. The profile version should be cleaned up and removed.
  // However, I am not doing it at this time as there is some refactor risk in doing so.
  // Going forward, new beta checks should use this reducer item instead of profile, as
  // profile only works when there is user context (not public appcenter).
  if (req.betas) {
    initialState.betas = req.betas;
  }
  if (req.cookies) {
    initialState.userPrefs.adobeAnalyticsAllowed = isAdobeAnalyticsAllowed(req);
  }
  store = createStoreWithMiddleware(_rootReducer.default, initialState);
  return store;
}